import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import teamData from "../data/teamData";
import useScrollAnimation from "../../hooks/UseScrollAnimation";
export default function Team() {
    const { t } = useTranslation();
    useScrollAnimation();
    const showData = teamData.map((el, index) =>
        <div key={index} className="w-100 js-scroll fade-btm w-[32%] shadow-[0px_0px_10px_#00000017] rounded-[8px]">
            <div className="w-full h-[300px]">
                <img className="w-[100%] h-[100%] border-b-[3px] border-[#017e89] rounded-t-[8px]" src={el.image} alt="" />
            </div>
            <div className="p-[20px] flex flex-col justify-between gap-[25px]">
                <div>
                    <div className="font-bold text-[#017E89] text-[20px] capitalize">{t(`${el.name}`)}</div>
                    <div className="capitalize">{t(`${el.posation}`)}</div>
                </div>
                <Link
                    to={`/teamDetails/${el.id}`}>
                    <span className="capitalize font-bold">{t("view profile")}</span>
                    <img className="h-auto" src={require("../../assets/icons/twoLines.svg").default} alt="" />
                </Link>
            </div>
        </div>
    )
    return (
        <>
            <section className="landingpages">
                <div className="container h-full flex flex-col items-center justify-center text-center">
                    <div className="btmAni1256 text-[#017E89] font-bold text-[35px] capitalize">{t("Our Team")}</div>
                    <div className="btmAni2000 flex items-center gap-[5px] fonbold">
                        <Link to={"/"}>{t("Home")}</Link>
                        -
                        <span className="text-[#017E89] capitalize">{t("Our Team")}</span>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[50px]">
                    <div className="btmAni25002 flex items-baseline gap-[7px]">
                        <img className="w-[35px] h-auto" src={require("../../assets/icons/lineTitle.svg").default} alt="" />
                        <div className="font-bold capitalize text-[25px] text-[#017e89]">{t("Our Team")}</div>
                    </div>
                    <div className="f-col flex justify-center flex-wrap gap-[20px]">
                        {showData}
                    </div>
                </div>
            </section>
        </>
    );
}